<template>
  <b-tab-item label="SUB SERVICES">
    <table class="table table is-hoverable table is-fullwidth">
      <ServiceResultHeader :service="parentService" :show-qty="false" />
      <SubServiceDetail
        v-for="sub_pcm in parentService.prices_costs_margins
          .sub_prices_costs_margins"
        :key="parentService.code + sub_pcm.code"
        :sub-service="sub_pcm"
        :service="parentService"
        :show-qty="false"
      />
    </table>
  </b-tab-item>
</template>

<script>
import ServiceResultHeader from "@/components/quote-views/_shared/ServiceResultHeader.vue";
import SubServiceDetail from "@/components/quote-views/_shared/SubServiceDetail.vue";

export default {
  name: "EditServiceSideBarTabsSubDetail",
  components: { SubServiceDetail, ServiceResultHeader },
  props: {
    formItineraryService: {
      type: Object,
      default: () => {},
    },
    parentService: {
      type: Object,
      default: () => {},
    },
    itinerary: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
};
</script>
